import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacySk9() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`IX.`}
            <br />
            {` Zasílání obchodních sdělení a ukládání cookies`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Uživatel souhlasí se zasíláním informací souvisejících se službami poskytovatele na elektronickou adresu uživatele a dále souhlasí se zasíláním obchodních sdělení poskytovatele na elektronickou adresu uživatele.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={2} className={sList}>
            <li>{`Uživatel souhlasí s ukládáním tzv. cookies na jeho počítač, kdy jednotlivé podmínky odsouhlasí uživatel v rámci přístupu na webové stránky poskytovatele. `}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacySk9;
